// Subscription statuses that count as holding a subscription. Shared by
// useIsSubscribed and server-side gates that must agree with it.
export function isActiveSubscriptionStatus(subscriptionStatus) {
    return (subscriptionStatus === 'active' ||
        subscriptionStatus === 'trialing' ||
        subscriptionStatus === 'white_glove_past_due');
}
//# sourceMappingURL=subscriptionStatus.js.map